import { Component, computed, inject, signal } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { EditorService } from "../services/editor.service"
import { SaveIconComponent } from "../../shared/save-icon.component"

@Component({
  imports: [
    FormsModule,
    SaveIconComponent,
  ],
  standalone: true,
  template: `
    <div>
      Layer (from back to front): {{ positionLayer() }}/10
      <e2e-save-icon [modelChange]="modelChange()" />
    </div>
    <div style="padding: 0 15px">
      <input
        type="range"
        min="0"
        max="10"
        class="range range-secondary w-full"
        [ngModel]="positionLayer()"
        (ngModelChange)="change($event)"
      />
    </div>
  `,
  selector: "e2e-editor-layout-layer",
})
export class EditorLayoutLayerComponent {
  private editorService = inject(EditorService)

  positionLayer = computed(() => this.editorService.editorContent()?.settings.position.layer || 0)
  modelChange = signal<number | undefined>(undefined)

  change(layer: number) {
    this.modelChange.set(Date.now())
    const content = this.editorService.editorContent()
    if (content) {
      this.editorService.queueEditor({
        ...content,
        settings: {
          ...content.settings,
          position: {
            ...content.settings.position,
            layer,
          },
        },
      })
    }
  }
}
